import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { className: "container mt-20 flex flex-col p-4 shadow-xl   backdrop-blur-xl blur-lg" }
const _hoisted_2 = { class: "bg-gradient-to-r from-green-500 via-blue-300 font-semibold to-yellow-400 text-white text-2xl px-2 py-2" }
const _hoisted_3 = { class: "flex flex-col justify-center timeline-nav" }
const _hoisted_4 = { class: "flex justify-center py-4 space-x-8" }
const _hoisted_5 = ["data-test", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timeline_post_vue = _resolveComponent("timeline-post-vue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, " Posts for " + _toDisplayString(_ctx.currentPeriod.toLowerCase()), 1),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period) => {
          return (_openBlock(), _createElementBlock("a", {
            class: _normalizeClass(["font-semibold text-gray-700 border-gray-700", {
            'border-b-2 font-medium': period === _ctx.currentPeriod,
          }]),
            key: period,
            "data-test": period,
            onClick: ($event: any) => (_ctx.setPeriod(period))
          }, _toDisplayString(period), 11, _hoisted_5))
        }), 128))
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
      return (_openBlock(), _createBlock(_component_timeline_post_vue, {
        key: post.id,
        post: post
      }, null, 8, ["post"]))
    }), 128))
  ]))
}